import { HOST_API } from 'src/config-global';
import type { RecipeListOutput, RecipeUserListInput } from 'src/types/backend/generated';

// ----------------------------------------------------------------------

const RECIPE_LIST_FOR_USER_API_URI = '/api/recipe/user/list';

// ----------------------------------------------------------------------

export async function getRecipeListForUser(
  recipeData: RecipeUserListInput
): Promise<RecipeListOutput | null> {
  const params: RequestInit = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(recipeData),
  };

  const response = await fetch(`${HOST_API}${RECIPE_LIST_FOR_USER_API_URI}`, params);

  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }

    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }

    throw new Error(message);
  }

  return response.json();
}

